import React from 'react';
import { Icon, Button } from '@scuf/common';
import './NotFound.scss';
import { useHistory } from 'react-router-dom';

export default function NotFoundPage() {
  let history = useHistory();
  return (
    <div className="not-found-container">
      <div className="not-found">
        <Icon name="badge-warning" size="xlarge" />
        <h1 id="headerPageNotFound">Page Not Found</h1>
        <Button
          className="routeToHomeButton"
          onClick={() => history.push('/')}
          type="secondary"
          content="Return to landing page."
        />
      </div>
    </div>
  );
}
